export default "__VITE_ASSET__DQon2X$i__"